<template lang="pug">
server-data(
  v-if="!!request"
  :method="() => this.$user.deleteAccount.cancel()"
  :success-callback="() => $toast.success('Вы успешно отменили удаление аккаунта')"
  no-init
  v-slot="{ loading, init }"
)
  slot(v-bind="{ init, loading, deleteAt, deletedAt, daysToDelete }")
</template>

<script>
import { differenceInDays } from 'date-fns';

export default {
  components: {},
  props: {},
  computed: {
    request() {
      return this.$user.deleteAccount.request;
    },
    deleteAt() {
      return this.$dateprint.localeFormat(this.request?.delete_at);
    },
    deletedAt() {
      return this.$dateprint.localeFormat(this.request?.created_at);
    },
    daysToDelete() {
      const { delete_at, created_at } = this.request || {};
      if (!delete_at || !created_at) return 0;
      return differenceInDays(new Date(delete_at), new Date(created_at));
    },
  },
  methods: {},
};
</script>
